import React from "react";
import { SiteNav } from "./home/SiteNav";

// Legacy pages share the new FERAL header; solid yellow from the top so it stays legible.
const Navbar = () => <SiteNav overlay={false} />;

export default Navbar;
